import React, { Component } from "react";
import "./App.css";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import appStore from "./store";
import AppHeader from "./components/appHeader";
import AppFooter from "./components/appFooter";
import AlertComponent from "./components/alerts";
import RouteProvider from "./components/RouteProvider";
import LoginCheck from "./components/loginCheck";
import VersionCheck from "./components/versionCheck";
import Modal from "react-modal";

Modal.setAppElement("#root");

class App extends Component {
  render() {
    return (
      <Provider store={appStore}>
        <div className="App">
          <AlertComponent />
          <AppHeader />
          <Router>
            <RouteProvider />
          </Router>
          <LoginCheck />
          <VersionCheck
            enableInterval={true}
            intervalInSeconds={60 * 60} // 1 hour
          />
          <AppFooter />
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx